import CommonTermAndCondtion from '../commonfile/CommonTermAndCondtion'
import { useApartmentListClusterId } from '../../assets/api/useMarketingExecutive'
import useAuthStore from '../../store/useAuthStore'

const ZoneHeadTC = () => {
    const { user } = useAuthStore()
    const { data: ClusterApartmentList, isLoading: isClusterApartmentListLoading } = useApartmentListClusterId({ coordinator_id: user?.id })
    
    return (
        <CommonTermAndCondtion apartmentRow={ClusterApartmentList?.data} isloadingApartment={isClusterApartmentListLoading} />
    )
}

export default ZoneHeadTC